import { NPCs, fights, items, eventData, locations } from 'src/data'

const mockList = async (path: string) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 100))
  
  switch (path) {
    case 'npcs':
      return NPCs
    case 'fights':
      return fights
    case 'items':
      return items
    case 'quests':
      return eventData
    case 'locations':
      return locations
    default:
      return []
  }
}

const mockPost = async (_path: string, item: any, isVerified: boolean) => {
  await new Promise(resolve => setTimeout(resolve, 100))
  return { success: true, message: 'Mock data created', item: { ...item, isVerified } }
}

const mockPut = async (_path: string, item: any, isVerified: boolean) => {
  await new Promise(resolve => setTimeout(resolve, 100))
  return { success: true, message: 'Mock data updated', item: { ...item, isVerified } }
}

const mockDelete = async (_path: string, _item: any) => {
  await new Promise(resolve => setTimeout(resolve, 100))
  return { success: true, message: 'Mock data deleted' }
}

export default {
  list: mockList,
  post: mockPost,
  put: mockPut,
  delete: mockDelete
}
